import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=a6b02fa0&scoped=true"
import script from "./VideoPlay.vue?vue&type=script&lang=js"
export * from "./VideoPlay.vue?vue&type=script&lang=js"
import style0 from "./VideoPlay.vue?vue&type=style&index=0&id=a6b02fa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b02fa0",
  null
  
)

export default component.exports